import { previewModeRegex } from '../constants'

function removePreviewModeFromUrl(url) {
  return url.replace(previewModeRegex, '')
}

export default removePreviewModeFromUrl
